export const TABS = [
  { key: 'all', label: 'All Buyers', filters: {} },
  { key: 'sf', label: 'Single Family', filters: { market_tab: 'Single Family' } },
  { key: 'mf', label: 'Multifamily', filters: { market_tab: 'Multifamily' } },
  { key: 'hot', label: 'Hot Buyers', filters: { tier: 'Hot' } },
  { key: 'md', label: 'Miami-Dade', filters: { county: 'Miami-Dade' } },
  { key: 'bw', label: 'Broward', filters: { county: 'Broward' } },
  { key: 'segments', label: 'Saved Segments' },
  { key: 'campaigns', label: 'Campaigns' },
  { key: 'imports', label: 'Import History' },
];

export const COUNTIES = ['Miami-Dade', 'Broward', 'Palm Beach'];
export const MARKET_TABS = ['Single Family', 'Multifamily', 'Both'];
export const PROPERTY_TYPES = ['SFR', 'Townhouse', 'Condo', '2-4 Unit', '5+'];
export const STRATEGIES = ['Flipper', 'Holder', 'Mixed', 'Unknown'];
export const TIERS = ['Hot', 'Active', 'Cold'];
export const SOURCES = ['MLS Cash Sale', 'Active Listing Owner', 'Off Market'];
export const CALL_STATUSES = ['Not Called', 'Wrong Number', 'No Answer', 'Call Back Later', 'Interested', 'Not Interested', 'Do Not Call'];

export const TIER_STYLE = {
  Hot: 'bg-red-50 text-red-700 border-red-200',
  Active: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Cold: 'bg-slate-100 text-slate-600 border-slate-200',
};

export const FILTER_LABELS = {
  q: 'Search', county: 'County', market_tab: 'Market', tier: 'Tier', strategy: 'Strategy', property_type: 'Type', city: 'City', zip: 'Zip',
  min_count_in_zip: 'Min buys in area', zip_preference: 'Zip preference', call_status: 'Call status', has_mobile: 'Has mobile',
  not_dnc: 'Not DNC', sms_opt_in: 'SMS opt-in', tags: 'Tags', source: 'Source', price_min: 'Price ≥', price_max: 'Price ≤',
  beds_min: 'Beds ≥', baths_min: 'Baths ≥', last_purchase_within_days: 'Bought within (days)',
};

export const cleanFilters = (f) => Object.fromEntries(Object.entries(f).filter(([, v]) => v !== '' && v !== null && v !== undefined && v !== false));

export const money = (v) => (v ? `$${Number(v).toLocaleString(undefined, { maximumFractionDigits: 0 })}` : '—');
export const shortDate = (d) => (d ? new Date(`${String(d).slice(0, 10)}T00:00:00`).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: '2-digit' }) : '—');
export const fmtPhone = (p) => { const d = String(p || ''); return d.length === 10 ? `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}` : d; };
